import licenseRequest from "./licenseRequest.vue";
export default licenseRequest;
